import { Button } from "react-bootstrap";
import React, { useState, useEffect, useCallback } from "react";
import * as APIModels from "../../../../../models";
import Select, { ActionMeta } from "react-select";
import { TylerRecordService } from "../../../../../services/RecordsService";
import useInterval from "../../../../../helpers/hooks/useInterval";
import { TylerDataService } from "../../../../../services/DataService";
import { authenticationService } from "../../../../../services/authentication.service";
import { Token } from "../../../../../models/swagger/generated-client-service";

type MyOptionType = { label: string; value: string };

export default function CaseInformation(params: {
    submission: APIModels.Submission;
    onSearchComplete: (
        request: APIModels.CaseSearch,
        result: APIModels.CourtCase
    ) => void;
    setCases: (cases: APIModels.CourtCase[]) => void;
}) {
    const currentUser = authenticationService.currentUserValue as Token;

    type Delay = number | null;
    const [delay, setDelay] = useState(1000);
    const [isRunning, setIsRunning] = useState(false);
    const [statusId, setStatusId] = useState("");
    const [request, setRequest] = useState(new APIModels.CaseSearch());

    useInterval(
        () => {
            console.log("Polling");
            TylerRecordService.poll({ id: statusId }).then(
                (resp) => {
                    if (
                        resp.successful &&
                        resp.errorMessage != null &&
                        !resp.successful
                    ) {
                        if (resp.data?.length === 1) {
                            params.onSearchComplete(request, resp.data[0]);
                            params.setCases(resp.data!);
                            setIsRunning(false);
                            setSearching(false);
                        } else if (resp.data && resp.data?.length > 1) {
                            //We will need to show the modal to select which case
                            params.setCases(resp.data ?? []);
                            setIsRunning(false);
                            setSearching(false);
                        }
                    } else {
                        setErrorMessage(resp.errorMessage ?? "");
                        setIsRunning(false);
                        setSearching(false);
                    }
                },
                (error) => {
                    setSearching(false);
                    setIsRunning(false);
                    console.log(error);
                    setErrorMessage("An error has occurred");
                }
            );
        },
        isRunning ? delay : null
    );

    let options: MyOptionType[] = [];

    const [currentSubmission, setCurrentSubmission] = useState(
        params.submission
    );

    const [showMore, setShowMore] = useState(false);

    const [portalIdentifier, setPortalIdentifier] = useState(
        params.submission.portalIdentifier
    );
    const [countyId, setCountyId] = useState(
        params.submission.caseData!.countyID
    );
    const [countyOptions, setCountyOptions] = useState(options);
    const [counties, setCounties] = useState([] as APIModels.County[]);

    const [divisionId, setDivisionId] = useState(
        params.submission.caseData!.divisionID
    );
    const [divisionOptions, setDivisionOptions] = useState(options);

    const [courtType, setCourtType] = useState("");
    const [courtTypeOptions, setCourtTypeOptions] = useState(options);

    const [ucn, setUCN] = useState(params.submission.caseData!.ucn);
    const [caseNumber, setCaseNumber] = useState(
        params.submission.caseData!.courtCaseNumber
    );

    const [sequenceNumber, setSequenceNumber] = useState(
        params.submission.caseData!.sequenceNumber
    );
    const [year, setYear] = useState(params.submission.caseData!.year);
    const [partyId, setPartyId] = useState("");
    const [location, setLocation] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [organization, setOrganization] = useState("");

    const [searching, setSearching] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [searchResults, setSearchResults] = useState(
        [] as APIModels.CourtCase[]
    );

    useEffect(() => {
        setCurrentSubmission(params.submission);
        setPortalIdentifier(params.submission.portalIdentifier);
        setCountyId(params.submission.caseData!.countyID);
        setDivisionId(params.submission.caseData!.divisionID);
        setCourtType("");
        setUCN(params.submission.caseData?.ucn);
        setCaseNumber(
            params.submission.portalIdentifier === "FL"
                ? ""
                : params.submission.caseData?.courtCaseNumber
        );
        setSequenceNumber(
            params.submission.portalIdentifier === "FL"
                ? params.submission.caseData?.sequenceNumber
                : ""
        );
        setYear(
            params.submission.portalIdentifier === "FL"
                ? params.submission.caseData?.year
                : undefined
        );
        console.log(caseNumber);
    }, [params.submission]);

    useEffect(() => {
        if (portalIdentifier != undefined) {
            console.log(portalIdentifier);
            TylerDataService.getCountiesByPortal({
                state: portalIdentifier,
                all: false,
            }).then(
                (resp) => {
                    options = resp.map((v, _i) => {
                        return { value: v.id!, label: v.name! };
                    });
                    setCountyOptions(options);
                    setCounties(resp!);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [portalIdentifier]);

    useEffect(() => {
        if (counties.length > 0) {
            setPortalIdentifier(
                counties.find((c) => c.id == countyId)?.portalIdentifier
            );
        }
    }, [counties]);

    const onCountyChange = (
        value: MyOptionType | null,
        _actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCountyId(value?.value);
        setPortalIdentifier(
            counties.find((c) => c.id == value?.value)?.portalIdentifier
        );
    };

    const caseSearchClick = useCallback(async () => {
        const newRequest: APIModels.CaseSearch = {
            attorneyID: params.submission.attorneyID,
            ucn: "",
            caseNumber:
                sequenceNumber && sequenceNumber.length > 0 ? "" : caseNumber,
            countyID: countyId,
            state: portalIdentifier,
            divisionID: divisionId,
            courtIdentifier: courtType,
            sequenceNumber: sequenceNumber,
            year: year,
            locationIdentifier: location,
            partyIdentifier: partyId,
            firstName: firstName,
            lastName: lastName,
            organization: organization,
            username: currentUser?.username,
            passwordHash: currentUser?.authToken,
        };
        setRequest(newRequest);

        setSearching(true);
        //TylerRecordService.localCaseSearch({ body: newRequest })
        //    .then(
        //        // comment this block when we deploy these chanes to production
        //        (resp) => {
        //            // this is for testing purposes only, as it is faster than the
        //            if (resp.successful === true) {
        //                // longCaseSearch method as the lambda does not need to be warmed up
        //                if (resp.data && resp.data.length > 0) {
        //                    console.log(resp.data);
        //                    setSearchResults(resp.data);
        //                    return resp.data;
        //                }
        //            }
        //        },
        //        (error) => {
        //            setSearching(false);
        //            console.log(error);
        //            setErrorMessage("An error has occurred");
        //        }
        //    )
        //    .then((resp1) => {
        //        if (resp1 && resp1.length === 1) {
        //            params.onSearchComplete(request, resp1[0]);
        //            params.setCases(resp1!);
        //        } else if (resp1 && resp1.length > 1) {
        //            params.setCases(resp1 ?? []);
        //            setIsRunning(false);
        //        }
        //        setSearching(false);
        //        setIsRunning(false);
        //    });

        TylerRecordService.longCaseSearch({ body: newRequest }).then(
            // uncomment this block when we deploy these chanes to production
            (resp) => {
                // as the lambda needs to be warmed up, this method is slower than
                if (resp.successful === true) {
                    // the localCaseSearch method but in production it will be faster
                    if (!resp.data || resp.data! === APIModels.EmptyGuid) {
                        // as the case search will never be cold
                        setErrorMessage("No case found");
                        return;
                    }
                    setStatusId(resp.data!);
                    setIsRunning(true);
                    return;
                } else {
                    setErrorMessage(resp.errorMessage ?? "No case found");
                    setSearching(false);
                }
            },
            (error) => {
                setSearching(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [
        countyId,
        divisionId,
        courtType,
        sequenceNumber,
        year,
        caseNumber,
        ucn,
        location,
        partyId,
        firstName,
        lastName,
        organization,
        portalIdentifier,
    ]);

    const filterOption = (option: MyOptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <>
            <div className="row mb-3">
                <div className="col-sm-12"></div>
                <label htmlFor="selCounty" className="form-label">
                    County/Court
                </label>
                <Select
                    id="selCounty"
                    name="selCounty"
                    value={countyOptions.filter((c) => c.value === countyId)}
                    filterOption={filterOption}
                    options={countyOptions}
                    onChange={onCountyChange}
                />
            </div>
            <div className="row mb-3">
                <label htmlFor="txtCaseNumber" className="form-label">
                    Case Number
                </label>
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        id="txtCaseNumber"
                        placeholder="Case Number"
                        aria-describedby="inputGroupPrepend"
                        value={caseNumber}
                        onChange={(event) => {
                            setCaseNumber(event.currentTarget.value);
                        }}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-sm-12">
                    <Button
                        variant="link"
                        onClick={() => setShowMore(!showMore)}
                    >
                        More Options
                    </Button>
                    {showMore === true && (
                        <>
                            <div className="row mb-3">
                                <div className="col-sm-6">
                                    <label
                                        htmlFor="txtFirstName"
                                        className="form-label"
                                    >
                                        First Name
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtFirstName"
                                            placeholder="First Name"
                                            aria-describedby="inputGroupPrepend"
                                            value={firstName}
                                            onChange={(event) => {
                                                console.log(
                                                    event.currentTarget.value
                                                );
                                                setFirstName(
                                                    event.currentTarget.value
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <label
                                        htmlFor="txtLastName"
                                        className="form-label"
                                    >
                                        Last Name
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtLastName"
                                            placeholder="Last name"
                                            aria-describedby="inputGroupPrepend"
                                            value={lastName}
                                            onChange={(event) =>
                                                setLastName(
                                                    event.currentTarget.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <label
                                        htmlFor="txtOrganization"
                                        className="form-label"
                                    >
                                        Organization
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtOrganization"
                                            placeholder="Organization"
                                            aria-describedby="inputGroupPrepend"
                                            value={organization}
                                            onChange={(event) =>
                                                setOrganization(
                                                    event.currentTarget.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-sm-12">
                    {searching ? (
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Searching...
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={caseSearchClick}
                        >
                            Search
                        </button>
                    )}
                    <div>{errorMessage}</div>
                </div>
            </div>
        </>
    );
}
